import { NgModule } from '@angular/core';
import { SharepointService } from '../services/sharepoint.service';
import { RepositoryService } from '../services/repository';
import { ExtractSourcePipe } from '../pipes/extractSource.pipe';
import { CoreModule } from 'src/core/modules/core.Module';

@NgModule({
  declarations: [
    ExtractSourcePipe
  ],
  imports: [
    CoreModule
  ],
  exports:[
    ExtractSourcePipe,
    CoreModule
  ],
  providers:[
    SharepointService,
    RepositoryService
  ]
  
})
export class SharepointModule { 


}




